/**
 * Font the badge text renders in — must track LinkTypeBadgeStyled in ./styles.ts and the
 * theme's typography.fontFamily. Written as a CSS `font` shorthand for canvas measurement.
 */
const BADGE_FONT = '600 12px "Montserrat", sans-serif';

/** Badge padding (10 + 10) + DataGrid v5 cell padding (10 + 10) + a few px of slack. */
const HORIZONTAL_CHROME = 48;

/**
 * Floor, and the fallback when measurement is unavailable (no canvas in jsdom, fonts blocked).
 * Matches the width the column used before it was measured, so it degrades to the old look
 * rather than collapsing.
 */
const MIN_WIDTH = 140;

/** Reused across calls — creating a canvas per measurement is needless garbage. */
let measuringContext: CanvasRenderingContext2D | null | undefined;

const getMeasuringContext = (): CanvasRenderingContext2D | null => {
  if (measuringContext === undefined) {
    measuringContext = document.createElement('canvas').getContext('2d');
  }
  return measuringContext;
};

/**
 * Width the Type column needs to render its widest badge without clipping.
 *
 * DataGrid v5 has no content-based column sizing (`autosizeColumns` arrived in v6), so the
 * width is measured from the actual translated labels rather than guessed at. Because the
 * labels are the input, this adapts on its own when the language changes or when a
 * translation value turns out longer than expected.
 */
const measureBadgeColumnWidth = (labels: string[]): number => {
  const context = getMeasuringContext();
  if (!context) return MIN_WIDTH;

  context.font = BADGE_FONT;
  const widest = labels.reduce((max, label) => Math.max(max, context.measureText(label).width), 0);

  return Math.max(MIN_WIDTH, Math.ceil(widest) + HORIZONTAL_CHROME);
};

export default measureBadgeColumnWidth;
